import * as React from 'react';
import { hasPermissionToAccessPage } from 'helpers/permission-helper';
import { Permission } from 'types/permission';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps
} from 'react-router';

export interface Props {
  userPermissions: string;
  permissions: Permission[];
}

// tslint:disable-next-line:no-any
type RouteComponent = React.StatelessComponent<RouteComponentProps<{}>> | React.ComponentClass<any>;

export class PermissionRoute extends React.Component<Props & RouteProps, {}> {
  constructor(props: Props & RouteProps) {
    super(props);
  }

  public render() {
    const { component, ...rest } = this.props;
    return <Route {...rest} render={this.getComponentToRender(component)} />;
  }

  private getComponentToRender = (Component?: RouteComponent) => (props: RouteComponentProps) => {

    if (!Component) {
      return null;
    }

    if (this.isAllowedToAccess()) {
      return <Component {...props} />;
    }

    const redirectProps = {
      to: '/'
    };

    return <Redirect {...redirectProps} />;
  }

  private isAllowedToAccess() {
    return this.props.permissions.some(perm => {
      return hasPermissionToAccessPage(perm, this.props.userPermissions);
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/permission-route/component.tsx